import * as yup from 'yup';

export const loginSchema = yup.object().shape({
  identifier: yup
    .string()
    .required('Email or phone number is required'),
  otp: yup
    .string()
    .required('OTP is required')
    .matches(/^[0-9]{6}$/, 'OTP must be 6 digits')
    .test('len', 'OTP must be exactly 6 digits', (val) => {
      return val ? val.length === 6 : false;
    }),
});
